export const SET_ALERT = "ALERT.SET_ALERT";
export const REMOVE_ALERT = "ALERT.REMOVE_ALERT";